import React from "react";

export default function Footer() {
  return (
    <div className="dark:bg-primary-dark dark:text-t-dark text-center mt-5">
      Made with love by Nishant
    </div>
  );
}
